var map = {
	"./de.json": "ZBY7",
	"./en_uk.json": "Hnog",
	"./en_us.json": "beky",
	"./es.json": "nKod",
	"./fr.json": "dNj6",
	"./pt.json": "Zyyk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d80J";


//////////////////
// WEBPACK FOOTER
// ./src/langs ^\.\/.*\.json$
// module id = d80J
// module chunks = 0